import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { surfaceForHost } from "@lunavoa/brand";
import "./styles.css";

const surface = surfaceForHost(window.location.hostname);
if (window.location.pathname === "/" && surface !== "public") window.history.replaceState(null, "", surface === "parent" ? "/app" : "/admin");

createRoot(document.getElementById("root")!).render(<StrictMode><BrowserRouter><App /></BrowserRouter></StrictMode>);
